export enum ErrorType {
  Htttp = 'http',
  App = 'app',
}
